import { ApplicationConfig, ErrorHandler, provideZonelessChangeDetection } from '@angular/core';
import {
  provideHttpClient,
  withInterceptors,
  withFetch,
} from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { authInterceptorFn } from './interceptors/auth.interceptor';
import { GlobalErrorHandler } from './core/global-error.handler';

import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { provideEchartsCore } from 'ngx-echarts';

import * as echarts from 'echarts/core';
import { BarChart, LineChart, PieChart, ScatterChart, HeatmapChart } from 'echarts/charts';
import {
  GridComponent,
  TooltipComponent,
  LegendComponent,
  TitleComponent,
  DataZoomComponent,
  ToolboxComponent,
  VisualMapComponent
} from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';

echarts.use([
  BarChart,
  LineChart,
  PieChart,
  ScatterChart,
  HeatmapChart,
  GridComponent,
  TooltipComponent,
  LegendComponent,
  TitleComponent,
  DataZoomComponent,
  ToolboxComponent,
  VisualMapComponent,
  CanvasRenderer
]);

import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),

    provideHttpClient(
      withInterceptors([authInterceptorFn]),
      withFetch()
    ),

    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    },

    provideCharts(
      withDefaultRegisterables()
    ),

    provideAnimationsAsync(),

    // Angular 20 Zoneless change detection (graduated from experimental)
    // All components use OnPush + signals, so Zone.js is no longer needed
    provideZonelessChangeDetection(),

    provideEchartsCore({
      echarts
    }),
  ]
};
